// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linkcolor[data-v-8ddc8762] {\n  color: #1a96d4;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
